import '../../../assets/css/offers_calls.css';
import React, { useState , useEffect } from 'react';
import { useHistory } from "react-router-dom";

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {makeStyles} from '@mui/styles';
import Pagination from "react-js-pagination";
import swal from 'sweetalert';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import FolderIcon from '@mui/icons-material/Folder';
import { archive_offer_call, get_offers_calls, get_service_infos } from '../../../services/purchase_service';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Add_proposal from './add_proposal/add_proposal';
import Update_proposal from './add_proposal/update_propsal';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view';
import { get_ao_docs, get_categories_forAll_services } from '../../../services/for_allServices';
import Docs_modal from '../../docs_modal/docs_modal';


const useStyles = makeStyles((theme) => ({
  button: { margin: 8,},
  root: {
    '& > *': {
      margin: 8,
    },
  },
  input: {
    display: 'none',
  },
}));


function setDateTime(date){
  let day = date.toISOString();
  let day_comp = day.split(":");
  return day_comp[0]+":"+day_comp[1];
}


function CompareFinalDate_current(finalDate){
  let day = new Date(finalDate);
  let current_date = new Date();
  if(day.getTime() <= current_date.getTime()) return false;
  else return true;
}


function Offers (){

  let user = JSON.parse(localStorage.getItem('user-info'));
  let history = useHistory();

  const classes = useStyles();
  const dateToday = setDateTime(new Date());
  const [url_updated , setUrl_updated] = useState(null);

  const [clickOffre, setClickOffre] = useState(null);
  
  const [offers , setOffers] = useState(null);
  const [offers_added , setOffers_added] = useState(null);

  const [chosenOffer,setchosenOffer]=useState("");
  const [update , setUpdate] = useState(false);
  const [categories,setCategories]=useState([]);

  const [filter_categorie,setFilter_categorie]=useState("all");
  const [search_value,setsearch_value]=useState("");
  const [search_filter,setsearch_filter]=useState('all');
  const [profilInfo,setprofilInfo]=useState({});

  const [currentPage,setCurrentPage]=useState(1);
  const [dataPerPage,setdataPerPage] =useState(6);
  const [data_count,setdata_count]=useState(0);
  const [waiting, setWaiting] = useState(false);


  const [chosen_docs, setchosen_docs] = useState(null);
  const [open, setOpen] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);

  const handleClose = () => { 
    setOpen(false);
    setchosenOffer("");
    setClickOffre(null);
   };
  

   const handleCloseAdd = () => {
    setOpenAdd(false); 
  };
  function HandleClickAdd(){
    setUpdate(false);
    setOpenAdd(true);
    //console.log(openAdd);
  };

  const HandleClickOpen = (offer,index) => {
    setchosenOffer(offer);
    setClickOffre(index);
    setOpen(true);
    setUpdate(true);
  };

  useEffect(()=>{
    setdata_count(0);
    setOffers(null);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var tmp_searchFilter ="all";
    var tmp_searchValue = null;
    var tmp_filterCategorie = "all";

    async function set_filter(){
      if(urlParams.get('filtre') && urlParams.get('valeur')){
        tmp_searchFilter = urlParams.get('filtre');
        tmp_searchValue = urlParams.get('valeur');
      }if(urlParams.get('categorie')){
        tmp_filterCategorie = urlParams.get('categorie');
      }
      await setsearch_filter(tmp_searchFilter);
        await setsearch_value(tmp_searchValue);
        await setFilter_categorie(tmp_filterCategorie);
    }
    
    async function load_data(){
        await set_filter();
        await get_categories_forAll_services().then((response)=> {
          setCategories(response.data);
        }).catch((error)=>{
          //console.log(error.response);
        });
        let page = (urlParams.get('page')?urlParams.get('page'):1);
        await setCurrentPage(page)

        await get_offers_calls(user.id,tmp_filterCategorie,tmp_searchFilter,tmp_searchValue,page).then((response)=> {
          setdata_count(response.data.total);
          setOffers(response.data.data);
        }).catch((error) => {
          //console.log(error.response);
        });

        await get_service_infos(user.id).then((response)=> {
          setprofilInfo(response.data)
        }).catch((error) => {
          //console.log(error.response);
        });
    }

    load_data();

  },[url_updated,offers_added]);

 
  function getCategorieById(id){
    var categorie="";
    categories.map((catg)=>{
      if(catg.id_category == id) categorie = catg.name;
    })
    return categorie;
  }

  async function delete_proposal(id){
    swal({
        title: "Etes-vous sûr ?",
        text: "!!!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        setWaiting(true);
        const formData = new FormData();
        formData.append('offer_id',offers[id].offer_id);
        formData.append('id_service',user.id);
        archive_offer_call(formData).then((response) => {
          setWaiting(false);
          let tmp_offers = [ ...offers ];
          tmp_offers.splice(id,1);
          setOffers(tmp_offers);
        }).catch((error) => {
          setWaiting(false);
          swal("Il y a des soumissions non traitées liées à l'appel d'offres !", {
            icon: "error",
            buttons: true,
          });
          //console.log(error.response);
        });
      }
    });
  }



  function search(){
    setsearch_value(search_value);
    let path = window.location.href.split('?')[0]
    if(filter_categorie!=="all") history.push("/serviceAchat/mesAppelsOffres?categorie="+filter_categorie+"&filtre="+search_filter+"&valeur="+search_value);
    else history.push("/serviceAchat/mesAppelsOffres?filtre="+search_filter+"&valeur="+search_value);
    setOffers_added(search_value);
  }


  function view_docs(ao_id){
    setWaiting(true);
    setchosenOffer(ao_id);
    //console.log(ao_id);
    get_ao_docs("ao",ao_id).then((response)=>{
      setchosen_docs(response.data);
      setWaiting(false);
    }).catch((error)=>{
      setWaiting(false);
      //console.log(error.response);
    })
  }

  function set__categorie(value){
    setFilter_categorie(value);
    let path = window.location.href.split('?')[0]
    if(value!=="all") history.push("/serviceAchat/mesAppelsOffres?categorie="+value);
    else history.push("/serviceAchat/mesAppelsOffres?categorie=all");
    setOffers_added(value);
  }

  function set__filter(value){
    if(value==="all"){
      setsearch_filter(value);
      let path = window.location.href.split('?')[0]
      if(filter_categorie!=="all") history.push("/serviceAchat/mesAppelsOffres?categorie="+filter_categorie+"&filtre="+value);
      else history.push("/serviceAchat/mesAppelsOffres?filtre="+value);
      setOffers_added(value);
    }else setsearch_filter(value);
  }

    async function change_page(page){
      await setCurrentPage(page);
      let path = history.location.pathname;
      let params = history.location.search;
      let search_params = params.split('&');
      let tmp_params = path;
      if(!params) history.push(path+"?page="+page);
      else{
        for(let i in search_params){
          if(search_params[i].includes("page=")){
            if(i==0) tmp_params=tmp_params+"?page="+page;
            else tmp_params=tmp_params+"&page="+page;
          }else{
            if(i==0) tmp_params=tmp_params+search_params[i];
            else tmp_params=tmp_params+"&"+search_params[i];
          }
        }
        if(!tmp_params.includes("page=")) tmp_params=tmp_params+"&page="+page;
        history.push(tmp_params);
      }
      await setUrl_updated(page);
    }
    
return (
  <>
    {
      offers===null
      ?<Loading_animation_view />
      :  <div className="my_offers_container">
          <div className="my_offers_container_header">
              <div className='addButton_container'>
                <Tooltip title="Ajouter">
                  <Fab className="add_new_object_fab add_new_object_fab_big" onClick={HandleClickAdd} >
                    <AddIcon className="add_new_object_icon" />
                  </Fab>
                </Tooltip>
              </div>
              <div className='search_filter_container'>
                <FormControl variant='standard' className="header_form" >
                    <InputLabel id="demo-simple-select-helper-label">Famille d'achat</InputLabel>
                    <Select required value={filter_categorie} 
                        onChange={e => {set__categorie(e.target.value) }} >
                        
                        <MenuItem value={"all"}>Toutes les familles d'achat</MenuItem>
                        {
                        categories.map((categorie,id)=>(
                            <MenuItem value={categorie.id_category} key={id} >{categorie.name}</MenuItem>
                        ))
                        }
                        
                    </Select>
                </FormControl>

                <FormControl variant='standard' className="header_form">
                  <InputLabel id="demo-simple-select-helper-label">Filtre</InputLabel>
                  <Select value={search_filter}  onChange={(e)=>{set__filter(e.target.value)}}>
                    <MenuItem value="all">Aucun</MenuItem>
                    <MenuItem value='Object'>Objet d'appel</MenuItem>
                    <MenuItem value='Direction'>Direction</MenuItem>
                  </Select>
                </FormControl>

                  <Grid container spacing={1} alignItems="flex-start" className={search_filter==="all"?"search_bar disabled_button":"search_bar" } >
                    <Grid item>
                      <SearchIcon onClick={search} className={search_value==""?"my_icon disabled_button":"my_icon" } style={{cursor:"pointer"}}  />
                    </Grid>
                    <Grid>
                      <TextField variant='standard' label="Chercher" value={search_value} onChange={(e)=>{setsearch_value(e.target.value)}}/>
                    </Grid>
                  </Grid>
                </div>
            </div>
            <div className="offers_contents_pagination_container">
                {
                  offers.length !== 0
                  ?<><div className="offers_contents_container">
                    {
                      offers.map((val,index,i=0) => {
                        return (
                            <div className="main_card_container" key={val.id}>
                                <div className="main_card_infos_container">
                                        <div className="main_card_offer_object">{val.object}</div>
                                        <div className="main_card_infos_content">
                                          <div className="main_card_infos_elements">
                                              <div> <span>Famille d'achat : </span>{getCategorieById(val.purchase_family)}</div>
                                              <div><span>Estimation : </span>{val.estimation} DH</div>
                                          </div>
                                          <div className="main_card_infos_elements">
                                              <div><span>Direction :</span> {val.direction} </div>
                                              <div><span>Date Offre : </span>{(new Date(val.offer_date)).toLocaleString()}</div>
                                          </div>
                                          <div className="main_card_infos_element"><span>Date Limite :</span> {(new Date(val.limit_date)).toLocaleString()}</div>
                                          <div className="main_card_infos_element"> <span>Date d'ouverture des plis : </span>{(new Date(val.openOffer_date)).toLocaleString()}</div>
                                        </div>
                                </div>
                  
                                <div className="card_buttons_container">
                                    {/* <Tooltip title="Documents" placement="bottom">
                                        <span style={{margin:"0",padding:"0",marginRight:'10px'}}>
                                            <Fab size="small" color="info" onClick={() => view_docs(val.offer_id)} >
                                                <FolderIcon className="my_icon"  />
                                            </Fab>
                                        </span>
                                    </Tooltip> */}
                                    
                                    <Tooltip title="Archiver">
                                          <Fab className={classes.button+" "+(CompareFinalDate_current(val.dateLimite) === false  ? "cancel_object_fab disabled_button" : "cancel_object_fab")} onClick={()=>delete_proposal(index)} >
                                            <DeleteIcon className="my_icon" />
                                          </Fab>
                                        </Tooltip>
                                        <Tooltip title="Modifier">
                                          <Fab className={classes.button+" "+("success_object_fab")} onClick={()=>HandleClickOpen(val,index)} >
                                            <EditIcon className="my_icon" />
                                          </Fab>
                                        </Tooltip>
                                </div>
                            </div>
                  
                           );
                        }
                      )
                    }
                  </div>
                  <div className="pagination_container">
                          <Pagination
                              activePage={Number(currentPage)}
                              itemsCountPerPage={dataPerPage}
                              totalItemsCount={Number(data_count)}
                              pageRangeDisplayed={4}
                              onChange={change_page.bind(this)}
                          />
                      </div>
                  </>:<>Aucun appel d'offre disponible</>
                }
          </div>

      </div>
    }
  

    {
      openAdd!==false
      ?<Add_proposal 
            open={openAdd} onClose={handleCloseAdd} 
            dateToday={dateToday} handleCloseAdd={handleCloseAdd} openAdd={openAdd} offers={offers}
            setOffers={setOffers} profilInfo={profilInfo} update={update} setOffers_added={setOffers_added} categories={categories} />
      :<></>
    }
      
      {
        clickOffre!=null
        ?<Update_proposal handleClose={handleClose} onClose={handleClose} open={open} chosenOffer={chosenOffer} offers={offers}
            clickOffre={clickOffre} setOffers={setOffers} profilInfo={profilInfo} update={update} categories={categories} />
        :<></>
      }

      {
        chosen_docs!==null
        ?<Docs_modal docs={chosen_docs} setDocs={setchosen_docs} wf={"ao"} wf_identifier={chosenOffer} />
        :<></>
      }

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={waiting}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        
    </>
  )
}
export default Offers
